/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {shopSearchBrands} from '../api'

export const useMutationShopSearchBrands = createReactQueryMutationHook('shopSearchBrands', shopSearchBrands)
